import { Component } from '@basic-orange/component';

export default class Tabs extends Component {
    constructor(elm, componentId) {
        super(elm, componentId);

        setTimeout(() => {
            if (Foundation.MediaQuery.atLeast('xmedium')) {
                this.$elm = $(elm);
                this.elmBoundingBox = $.rectangle(elm);
                this.$article = $('article');
                this.$header = $('.header');

                this.stickyPoint = this.$elm.offset().top;

                this.setEventListeners();

                this.init();
            }
        }, 1000);
    }

    init() {
        setTimeout(() => {
            var scrollPosition = $(window).scrollTop() + 1;
            $(window).scrollTo(scrollPosition, 1);
        }, 400);
    }

    setEventListeners() {
        $(window).on('scroll', this.onScroll.bind(this));
    }

    onScroll(event) {
        var scrollTop = $(window).scrollTop();
        var headerBoundingBox = $.rectangle($('header'));
        var elmBoundingBox = $.rectangle(this.elm);

        if (scrollTop > this.stickyPoint) {
            this.$elm
                .css({ marginTop: headerBoundingBox.height - 1 + 'px'})
                .addClass('Tabs--isSticky');

            this.$article.css({ marginTop: (headerBoundingBox.height + elmBoundingBox.height + 64) + 'px' });
            this.$header.addClass('header--inpageNavigationIsFixed');
        } else {
            this.$elm
                .css({ marginTop: 0 })
                .removeClass('Tabs--isSticky');

            this.$article.css({ marginTop: 0 });
            this.$header.removeClass('header--inpageNavigationIsFixed');
        }

        this.lastScrollTop = scrollTop;
    }
}